import { SharedContent } from './shared-content';

export const TransferFromContent = {
  joint: {
    title: 'Select the joint account(s) you would like to inherit',
    accordion: [
      {
        accordionTitle: `Why don't I see my other accounts?`,
        accordionDescription: `If you have other Vanguard accounts and don't see them listed, it's because we can only transfer certain accounts online at this time. Please call us at <span class="bold">877-662-7447</span> if you'd like to transfer any accounts you don't see here.`,
      },
    ],
  },
  continueButton: SharedContent.buttons.continueButton,
  minor: {
    title: `First, select the minor account(s) you would like to transfer`,
    subheading: `Through this process, you’ll be able to transfer UGMA or UTMA accounts to an individual nonretirement account.`,
    accordion: [
      {
        accordionTitle: `What is an individual nonretirement account?`,
        accordionDescription: `This account type is for one owner, and is geared toward general investing for both short- and long-term goals. An individual nonretirement brokerage account gives access to a variety of products such as mutual funds (e.g., index, actively managed, or money market funds), ETFs, individual stocks and bonds, and CDs. A Vanguard Brokerage Account can be used as a nonretirement account to take full control of your UGMA/UTMA assets. Earnings you may receive (dividends, capital gains distributions, interest, etc.) can be considered taxable income. Gains from selling investments can also be considered taxable income. An individual’s SSN is used for tax purposes in an individual nonretirement account as it is in the UGMA/UTMA.`,
      },
      {
        accordionTitle: `What will happen to my investments?`,
        accordionDescription: `Before you can access your investments, money from your UGMA/UTMA must be moved into an individual nonretirement account you open with Vanguard. Typically, this takes 5-7 business days. When done, you will maintain full control of your assets-and can buy, sell, invest, and manage your money as you wish.`,
      },
    ],
  },
  loadingSpinner: SharedContent.loadingSpinner,
};
